import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Body } from '@components/templates/PageBody';

export const StyledFlexColumnsWrapper = styled.main`
  width: 100%;
`;

export const StyledStatusWrapper = styled.div`
  cursor: pointer;

  &:hover {
    color: #7fe200;
    text-decoration: underline;
  }

  &.waiting {
    color: #828282;
    cursor: default;

    &:hover {
      color: #828282;
      text-decoration: none;
    }
  }
`;

export const StylePDFBodyRow = css`
  thead tr {
    height: 32px;
  }

  thead tr th {
    font-size: 12px;

    &:nth-of-type(1) {
      width: 50px;
    }

    &:nth-of-type(4),
    &:nth-of-type(5),
    &:nth-of-type(7) {
      width: 85px;
    }

    &:nth-of-type(8) {
      width: 150px;
    }
  }

  tbody tr {
    font-size: 12px;

    td:nth-of-type(8) {
      padding: 0 10px;
    }
  }
`;

export const StyledBodyRow = css`
  tr[data-highlight='ACTIVE' i] {
    td {
      background-color: #effdda;
      font-weight: bold;
      &[data-label='status'] {
        & div:after {
          content: ' >';
        }
      }
    }
  }
  tr[data-highlight^='WAIT' i] {
    td {
      background-color: #fafafa;
      color: #999999;
    }
  }
`;
export const StyledDelete = css`
  margin: auto;
  width: 90px;
  height: 24px;
  font-size: 14px;
  border-color: #ff4c4c;
  color: #ff4c4c;
  &:hover {
    background: #ffe8eb;
  }
  &:active {
    background: #ff4c4c;
  }
`;

export const LicenseHistoryBody = styled(Body)`
  margin-top: 15px;
  min-width: 505px;
  table {
    width: 100%;
    tbody > tr > td {
      background-color: #fafafa;
    }
  }
`;
